import React from "react";
import { Helmet } from "react-helmet-async";

const CivilMaintenanceSoftware = () => {
  return (
    <>
      <Helmet>
        <title>
          Underground Water Survey Division – Techno Land Engineers & Surveyors
        </title>
      </Helmet>

      <div class="rts-banner-area rts-section-gap rts-breadcrumb-area position-relative contact-bd">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb-area-inner">
                <h1 class="title">
                  Technoland’s Civil Maintenance Software – 2025
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="about-service-main-wrapper rts-section-gap bg_white"
        id="about"
      >
        <div class="container">
          <div class="row align-items-center">
            <div class="col-xl-5">
              <div class="thumbnail-main-wrapper-2">
                <div class="reveal-item overflow-hidden aos-init">
                  <div class="" data-aos="reveal-end"></div>
                  <img
                    src="assets/images/about/futuristic-technology-concept 1.png"
                    alt="underground-water-survey"
                  />
                </div>
              </div>
            </div>

            <div class="col-xl-7 pl--60 pl_md--0 pl_sm--10 pt_md--30 pt_sm--30">
              <div class="about-content-area-two">
                <div class="title-style-two-left">
                  <div class="title-left-align-five">
                    <span class="pre">
                      Technoland’s Civil Maintenance Software – 2025/
                    </span>
                    <h2 class="title mb--30">
                      Accurate Digital Replicas. Clear Insights. Better
                      Decisions. / (YCMOU) 
                    </h2>
                  </div>

                  <p class="disc">
                    Techno Land‘s Civil Maintenance Software – 2025 delivers a
                    smart and reliable way to understand the client’s existing
                    on-ground infrastructure. Designed for clarity and accuracy,
                    the platform creates a precise digital replica of the
                    client’s current civil assets, based entirely on detailed
                    field surveys conducted by our expert team.
                  </p>

                  <ul>
                    <li>
                      <b>Initial Detailed Survey:</b> Our engineers conduct a
                      comprehensive on-site survey to capture the exact
                      condition and layout of your infrastructure.
                    </li>
                    <li>
                      <b>Digital Replica Generation:</b> The collected data is
                      processed and presented in an easy-to-navigate digital
                      model, giving you a clear and complete view of your
                      “as-is” infrastructure.
                    </li>
                    <li>
                      <b>Quarterly Updates:</b> To ensure accuracy over time, we
                      perform quarterly surveys, updating your digital model
                      with the latest structural information. This helps you
                      monitor changes, anticipate issues, and plan maintenance
                      proactively.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="rts-offer-area-start rts-section-gap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="title-style-two-center inner">
                <span class="pre">Key Features .</span>
                <h2 class="title mb--40">
                  Advanced Surveying & Site Intelligence Solutions
                </h2>
              </div>
            </div>
          </div>

          <div class="row g-24">
            <div class="col-lg-6 col-md-12 col-12">
              <div class="single-offer-inner">
                <a href="#" class="thumbnail">
                  <img src="assets/images/about/route-map-tablet-screen 1.png" alt="offer" />
                </a>
                <div class="content-area">
                  <a href="#" class="title">
                    <h5 class="title">Accurate Utility Mapping</h5>
                  </a>
                  <p class="disc">
                    <li>
                      Maps electrical lines, water pipelines, sewerage,
                      stormwater drainage, and OFC cables
                    </li>
                    <li>
                      Helps document complete existing underground and
                      overground networks
                    </li>
                    <li>
                      Prevents delays caused by outages and inaccurate layouts.
                    </li>
                  </p>
                </div>
              </div>
            </div>

            <div class="col-lg-6 col-md-12 col-12">
              <div class="single-offer-inner">
                <a href="#" class="thumbnail">
                  <img src="assets/images/about/compass-clipboard-loupe 1.png" alt="offer" />
                </a>
                <div class="content-area">
                  <a href="#" class="title">
                    <h5 class="title">Precise Surveying Tools</h5>
                  </a>
                  <p class="disc">
                    <li>
                      Counter Survey: 1-meter interval for highly accurate
                      terrain modeling
                    </li>
                    <li>
                      Spot Level Survey: 10x10 meter grid capturing detailed
                      elevation data
                    </li>
                    <li>
                      TBM (Temporary Bench Mark): Fixed every 500 meters to
                      ensure a reliable and repeatable reference framework
                    </li>
                  </p>
                </div>
              </div>
            </div>

            <div class="col-lg-6 col-md-12 col-12">
              <div class="single-offer-inner">
                <a href="#" class="thumbnail">
                  <img src="assets/images/about/3d-cartoon-pin-location 1.png" alt="offer" />
                </a>
                <div class="content-area">
                  <a href="#" class="title">
                    <h5 class="title">Comprehensive Asset Location</h5>
                  </a>
                  <p class="disc">
                    <li>
                      Maps all major assets: substations, transformers,
                      buildings, walls, cabins
                    </li>
                    <li>
                      Captures infrastructure: internal roads, parking areas,
                      landscaping, gardens, water bodies
                    </li>
                    <li>
                      Enables the creation of a complete digital twin of the
                      entire site
                    </li>
                  </p>
                </div>
              </div>
            </div>

            <div class="col-lg-6 col-md-12 col-12">
              <div class="single-offer-inner">
                <a href="#" class="thumbnail">
                  <img src="assets/images/about/representation-user-experience-interface-design (1) 1.png" alt="offer" />
                </a>
                <div class="content-area">
                  <a href="#" class="title">
                    <h5 class="title">Intelligent Data Integration</h5>
                  </a>
                  <p class="disc">
                    <li>
                      All control points are connected through a unified
                      coordinate system
                    </li>
                    <li>
                      TBM-based standardization ensures consistent surveying
                      results
                    </li>
                    <li>
                      Generates a robust digital base map for planning, design,
                      and long-term maintenance
                    </li>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="about-service-main-wrapper rts-section-gap bg_white"
        id="about"
      >
        <div class="container">
          <div class="row align-items-center">
            <div class="col-xl-7 pr--60 pl_md--0 pl_sm--10 pt_md--30 pt_sm--30">
              <div class="about-content-area-two">
                <div class="title-style-two-left">
                  <div class="title-left-align-five">
                    <h2 class="title mb--30">
                      Benefits of Civil Maintenance Software:
                    </h2>
                  </div>

                  <ul>
                    <li>
                      <b>Improved Accuracy:</b> Eliminates guesswork with
                      precise utility and asset mapping
                    </li>
                    <li>
                      <b>Reduced Risks: </b> Minimizes chances of damage during
                      excavation, maintenance, or construction
                    </li>
                    <li>
                      <b>Optimized Resources:</b> Better planning helps reduce
                      repetitive tasks and unnecessary costs
                    </li>
                    <li>
                      <b>Faster Decision-Making:</b> Provides real-time insights
                      for quick and confident decisions
                    </li>
                    <li>
                      <b>Enhanced Operational Efficiency:</b> Streamlines
                      surveying, asset management, and maintenance workflows
                    </li>
                    <li>
                      <b>Centralized Data Access:</b> All reports, maps, and
                      survey data available in one digital platform
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-xl-5">
              <div class="thumbnail-main-wrapper-2">
                <div class="reveal-item overflow-hidden aos-init">
                  <div class="" data-aos="reveal-end"></div>
                  <img
                    src="assets/images/about/portrait-male-engineer-working-field-engineers-day-celebration 1.png"
                    alt="underground-water-survey"
                  />
                </div>
              </div>
            </div>
          </div>
            <div class="row align-items-center" style={{marginTop:"60px"}}>
            <div class="col-xl-5">
              <div class="thumbnail-main-wrapper-2">
                <div class="reveal-item overflow-hidden aos-init">
                  <div class="" data-aos="reveal-end"></div>
                  <img
                    src="assets/images/about/unrecognizable-man-neon-safety-vest-business-suit-sitting-desk-using-laptop 1.png"
                    alt="underground-water-survey"
                  />
                </div>
              </div>
            </div>
            <div class="col-xl-7 pl--60 pl_md--0 pl_sm--10 pt_md--30 pt_sm--30">
              <div class="about-content-area-two">
                <div class="title-style-two-left">
                  <div class="title-left-align-five">
                    <h2 class="title mb--30">
                     Advantages of Civil Maintenance Software:
                    </h2>
                  </div>

                  <ul>
                    <li>
                      <b> Clarity & Transparency:</b> Complete visibility of underground &
surface-level infrastructure
                    </li>
                    <li>
                      <b>Long-Term Usefulness: </b> Standardized digital base map supports
future projects and expansions
                    </li>
                    <li>
                      <b> High Reliability:</b>TBM references ensure consistent data across
different surveys and teams

                    </li>
                    <li>
                      <b>Better Planning Outcomes:</b> Helps design smarter layouts, improve
safety, and avoid costly errors
                    </li>
                    <li>
                      <b>Scalable System:</b> Can handle large campuses, industrial plants,
townships, and infrastructure networks

                    </li>
                    <li>
                      <b> Future-Ready Platform:</b> Supports modernization, smart asset
management, and predictive maintenance
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
          </div>
           <div class="row align-items-center"  style={{marginTop:"60px"}}>
            <div class="col-xl-7 pr--60 pl_md--0 pl_sm--10 pt_md--30 pt_sm--30">
              <div class="about-content-area-two">
                <div class="title-style-two-left">
                  <div class="title-left-align-five">
                    <h2 class="title mb--30">
                      Why Choose Our Current Version?
                    </h2>
                  </div>

                  <ul>
                    <li>
                      A reliable digital record of all existing structures

                    </li>
                    <li>
                     A reliable digital record of all existing structures

                    </li>
                    <li>
                      Consistent quarterly updates for ongoing accuracy
                    </li>
                    <li>
                      Centralized, easy-to-access information for engineering and
management teams

                    </li>
                   
                  </ul>
                  <p style={{marginBottom:"0px"}}><b>Future-Ready Platform</b><br></br>While the current version focuses on accurate digital documentation,
Techno Land is already developing the next advanced edition of the
software. The upcoming release, available as per client demand, will
introduce live structural views, instant layout updates, real-time
collaboration, and an integrated web and mobile experience.
</p>
<p><b>Build Clarity Today. Enable Smart Maintenance Tomorrow.
</b><br></br>With Techno Land’s Civil Maintenance Software – 2025, you gain a
dependable foundation for your maintenance planning and future digital
transformation.
</p>
                </div>
              </div>
            </div>
            <div class="col-xl-5">
              <div class="thumbnail-main-wrapper-2">
                <div class="reveal-item overflow-hidden aos-init">
                  <div class="" data-aos="reveal-end"></div>
                  <img
                    src="assets/images/about/warehouse-associate-fulfilling-purchases 1.png"
                    alt="underground-water-survey"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        
    </>
  );
};

export default CivilMaintenanceSoftware;
